'use strict';

var Transport = require('../transport');

var getRequestData = function(displayType, action, displayId, unit, data) {
  var request = {
    display_type: displayType,
    action: action,
    display_id: displayId,
    unit: unit
  };

  if (data && typeof data === 'object') {
    for (var name in data) {
      if (data.hasOwnProperty(name) && name !== 'content_raw') {
        request[name] = data[name];
      }
    }
  }

  return request;
};

module.exports = function(funnel) {
  var transport = new Transport('/block');

  return function(displayType, action, displayId, unit, data) {
    if (funnel._funnelWasSent) {
      var req = getRequestData(displayType, action, displayId, unit, data);
      var contentRaw = data && data.content_raw;

      funnel.addRelations(req);
      transport.debug = funnel.isDebug();

      transport.send(req, contentRaw);
    } else {
      funnel._preSendQueue.push({
        type: 'block',
        display_type: displayType,
        action: action,
        display_id: displayId,
        unit: unit,
        data: data
      });
    }
  };
};



//////////////////
// WEBPACK FOOTER
// ./lib/funnel/trackblock.js
// module id = 26
// module chunks = 1 3